import type { TutorAuditAttributes, TutorAuditFeaturedAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import TutorAuditQ from './TutorAuditQ'

const TutorAuditFeaturedQ = {
  ...makeQueryModelV2<TutorAuditFeaturedAttributes>('tutor_audit_featured')([
    'id',
    'tutor_audit_id',
    'user_id',
    'comment_key',
    'created_at',
    'deleted_at',
  ]),

  getTutorAudit: (): SQLFragment<TutorAuditAttributes> =>
    SQL`${TutorAuditQ.where({ id: TutorAuditFeaturedQ.tutor_audit_id })}`,

  getComment: (): SQLFragment<string> => SQL`
      CASE WHEN ${TutorAuditFeaturedQ.comment_key} IS NULL THEN ${TutorAuditQ.description}
      ELSE ${TutorAuditQ.details}->>${TutorAuditFeaturedQ.comment_key}
      END
    `,

  where: (
    {
      paranoid = true,
      userId,
      includeTutorAudit,
      tutorAuditId,
      groupBy = null,
      order = null,
    }: {
      paranoid?: boolean
      userId?: number | null | SQLFragment<number>
      includeTutorAudit?: boolean
      tutorAuditId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<TutorAuditFeaturedAttributes> => SQL`
        FROM ${TutorAuditFeaturedQ}
        ${
          includeTutorAudit === true
            ? SQL`INNER JOIN ${TutorAuditQ} ON ${TutorAuditQ.id} = ${TutorAuditFeaturedQ.tutor_audit_id}`
            : SQL``
        }
        WHERE
            ${
              tutorAuditId != null
                ? SQL`${TutorAuditFeaturedQ.tutor_audit_id} = ${tutorAuditId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${TutorAuditFeaturedQ.user_id} = ${userId} AND` : SQL``}
            ${paranoid ? SQL`${TutorAuditFeaturedQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default TutorAuditFeaturedQ
